import React from 'react';
import { Bell, Search, Menu, ShieldCheck } from 'lucide-react';

const Header = ({ onMenuToggle, notifications = [], darkMode, onToggleDarkMode, searchValue, onSearchChange }) => {
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <header className="admin-topbar bg-gray-900 border-b border-gray-800 px-6 py-3 flex items-center justify-between sticky top-0 z-40">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuToggle}
          className="lg:hidden text-gray-400 hover:text-white p-2"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="relative hidden sm:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <input
            type="text"
            placeholder="Pesquisar no painel..."
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            className="pl-9 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-sm text-white
                       placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#2e5bff]
                       focus:border-transparent w-72 transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="admin-secure-status"><ShieldCheck /><span><strong>Ambiente seguro</strong><small>Ligação protegida</small></span></div>

        {/* Notifications */}
        <div className="relative">
          <button className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors relative">
            <Bell className="w-5 h-5" />
            {unreadCount > 0 && (
              <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 text-white text-[10px] 
                               font-bold rounded-full flex items-center justify-center">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>
        </div>

        {/* Date */}
        <div className="hidden md:block text-sm text-gray-400">
          {new Date().toLocaleDateString('pt-PT', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;
